export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? '/api',
  eventSlug: import.meta.env.VITE_EVENT_SLUG ?? 'gravel-games-2027',
  stripeKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
  ga4Id: import.meta.env.VITE_GA4_MEASUREMENT_ID,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  /** Set by the deploy workflow: staging and production builds are both Vite `production`. */
  sentryEnvironment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  sentryRelease: import.meta.env.VITE_SENTRY_RELEASE || undefined,
} as const;
